import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { CalendarPlus } from '@phosphor-icons/react';

const LAST_SPORT_KEY = 'bttLastSport';

export default function BookFAB() {
  const [visible, setVisible] = useState(false);
  const [lastSport, setLastSport] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1400);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    try {
      const v = localStorage.getItem(LAST_SPORT_KEY);
      if (v) setLastSport(v);
    } catch {
      /* ignore */
    }
  }, [location]);

  // Hide on the booking page itself and on the contact page (form already there)
  if (location.pathname === '/book' || location.pathname === '/contact') return null;

  const href = lastSport ? `/book?sport=${lastSport}` : '/book';
  const label = lastSport
    ? `Book ${lastSport.charAt(0).toUpperCase() + lastSport.slice(1)} again`
    : 'Book a Session';

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.85 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.85 }}
          transition={{ type: 'spring', stiffness: 80, damping: 16 }}
          className="md:hidden fixed bottom-5 right-5 z-40 safe-area-bottom"
        >
          <Link
            to={href}
            className="flex items-center gap-2.5 pl-4 pr-5 py-3.5 rounded-full bg-gradient-to-br from-blue-600 to-blue-700 text-white shadow-sport-blue active:scale-95 transition-transform"
            aria-label={label}
          >
            <CalendarPlus size={22} weight="fill" />
            <span className="font-semibold text-sm">{label}</span>
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
